import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

// Асинхронное создание клиента из формы заказа.
// Форма клиента (clients/_form с in_modal) сабмитится через fetch → JSON.
// Успех: добавляем <option> в селект клиента, выбираем его, закрываем попап.
// Ошибка (422): показываем сообщения в попапе, страница не перезагружается.
export default class extends Controller {
  static targets = ["select", "modal", "form", "errors"]

  submit(event) {
    event.preventDefault()
    this.clearErrors()

    const form = this.formTarget
    const submitBtn = form.querySelector('[type="submit"]')
    if (submitBtn) submitBtn.disabled = true

    fetch(form.action, {
      method: "POST",
      body: new FormData(form),
      headers: {
        "Accept": "application/json",
        "X-CSRF-Token": this.csrfToken
      }
    })
      .then(async (response) => {
        const data = await response.json().catch(() => ({}))
        if (response.ok) {
          this.onSuccess(data)
        } else {
          this.showErrors(data.errors || ["Не удалось сохранить клиента."])
        }
      })
      .catch(() => this.showErrors(["Ошибка сети. Попробуйте ещё раз."]))
      .finally(() => { if (submitBtn) submitBtn.disabled = false })
  }

  onSuccess({ id, full_name, phone }) {
    const select = this.selectTarget
    // Текст с телефоном — тот же формат, что у select2 в templateSelection.
    const label = phone ? `${full_name} — ${phone}` : full_name
    const option = new Option(label, id, true, true)
    select.add(option)
    select.value = String(id)
    select.dispatchEvent(new Event("change", { bubbles: true }))

    // Select2 не следит за DOM селекта — сообщаем ему о новом варианте явно.
    const $ = window.jQuery
    if ($ && $(select).data("select2")) {
      $(select).trigger("change.select2")
    }

    this.formTarget.reset()
    Modal.getOrCreateInstance(this.modalTarget).hide()
  }

  showErrors(messages) {
    if (!this.hasErrorsTarget) return
    this.errorsTarget.classList.remove("d-none")
    this.errorsTarget.innerHTML =
      "<ul class='mb-0'>" + messages.map((m) => `<li>${m}</li>`).join("") + "</ul>"
  }

  clearErrors() {
    if (!this.hasErrorsTarget) return
    this.errorsTarget.classList.add("d-none")
    this.errorsTarget.innerHTML = ""
  }

  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content || ""
  }
}
